// External libraries
import React from 'react';

// Internal modules
import {
  HEADER_COLOR,
  PP_PRIMARY_COLOR,
  PP_SECONDARY_COLOR,
  PP_SUCCESS_COLOR,
  WARNING_COLOR,
} from '@/styles';

type IconDefaultProps = {
  fillColor?: string;
  height?: number;
  width?: number;
};

const CartIcon = ({
  color = HEADER_COLOR,
  height = 24,
  width = 24,
}: Omit<IconDefaultProps, 'fillColor'> & {
  color?: string;
}): React.ReactElement => (
  <svg
    height={height}
    viewBox={`0 0 ${height} ${width}`}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m3 6c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5h2.158c.68015008 0 1.27454519.45789792 1.4488838 1.11062833l2.07945275 7.51336477c.05846618.2207602.25861412.3760069.48366345.3760069h9.14c.2271328 0 .4261211-.1539426.4872391-.3888172l1.4578276-4.965915c.0801781-.30859902-.1407451-.6452678-.4840667-.6452678h-10.771c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5h10.771c1.0387128 0 1.6877524.98908315 1.4477609 1.91181719l-1.4577427 4.96558751c-.1711707.6606589-.768276 1.1225953-1.4510182 1.1225953h-9.14c-.68029094 0-1.27611509-.4621569-1.4488838-1.1146283l-2.07917871-7.51233445c-.05879804-.22011575-.25730471-.37303725-.48393749-.37303725zm7.5 12c0-.5518576-.4481424-1-1-1-.55185763 0-1 .4481424-1 1s.44814237 1 1 1c.5518576 0 1-.4481424 1-1zm1 0c0 1.1041424-.8958576 2-2 2-1.10414237 0-2-.8958576-2-2s.89585763-2 2-2c1.1041424 0 2 .8958576 2 2zm8 0c0-.5518576-.4481424-1-1-1s-1 .4481424-1 1 .4481424 1 1 1 1-.4481424 1-1zm1 0c0 1.1041424-.8958576 2-2 2s-2-.8958576-2-2 .8958576-2 2-2 2 .8958576 2 2z"
      fill={color}
    />
  </svg>
);

const ChevronIcon = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <img
    alt="Chevron"
    className={className}
    src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSI3cHgiIHZpZXdCb3g9IjAgMCAxNCA3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1NSAoNzgwNzYpIC0gaHR0cHM6Ly9za2V0Y2hhcHAuY29tIC0tPgogICAgPHRpdGxlPkljb25zL2NoZXZyb24tdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iVjItVVMtRm9yY2VkLUFjYyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlVTLUZvcmNlZC1hY2MtQ29weS0xMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMyOS4wMDAwMDAsIC0xMDMuMDAwMDAwKSIgZmlsbD0iIzJDMkUyRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IkhlYWRlci9SWUkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCA3Ny4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJTdGFja2VkLUdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNDEuMDAwMDAwLCAxOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iSWNvbnMvY2hldnJvbi11cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODIuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNi4zNTM1NTMzOSwxNC44NTM1NTM0IEM2LjE1ODI5MTI0LDE1LjA0ODgxNTUgNS44NDE3MDg3NiwxNS4wNDg4MTU1IDUuNjQ2NDQ2NjEsMTQuODUzNTUzNCBDNS40NTExODQ0NiwxNC42NTgyOTEyIDUuNDUxMTg0NDYsMTQuMzQxNzA4OCA1LjY0NjQ0NjYxLDE0LjE0NjQ0NjYgTDExLjY0NjQ0NjYsOC4xNDY0NDY2MSBDMTEuODQxNzA4OCw3Ljk1MTE4NDQ2IDEyLjE1ODI5MTIsNy45NTExODQ0NiAxMi4zNTM1NTM0LDguMTQ2NDQ2NjEgTDE4LjM1MzU1MzQsMTQuMTQ2NDQ2NiBDMTguNTQ4ODE1NSwxNC4zNDE3MDg4IDE4LjU0ODgxNTUsMTQuNjU4MjkxMiAxOC4zNTM1NTM0LDE0Ljg1MzU1MzQgQzE4LjE1ODI5MTIsMTUuMDQ4ODE1NSAxNy44NDE3MDg4LDE1LjA0ODgxNTUgMTcuNjQ2NDQ2NiwxNC44NTM1NTM0IEwxMiw5LjIwNzEwNjc4IEw2LjM1MzU1MzM5LDE0Ljg1MzU1MzQgWiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="
  />
);

const InfoIcon = ({
  fillColor = '#FFF',
  strokeColor = '#FF9600',
  width = 18,
  height = 18,
}: IconDefaultProps & { strokeColor?: string }): React.ReactElement => (
  <svg
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M-31-1279h360V477H-31z" fill={fillColor} />
      <g transform="translate(-13 -13)">
        <rect
          fill={fillColor}
          height="64"
          rx="4"
          stroke={strokeColor}
          width="323"
          x=".5"
          y=".5"
        />
        <path
          d="M21 13c-4.411 0-8 3.59-8 8 0 4.412 3.589 8 8 8s8-3.588 8-8c0-4.41-3.589-8-8-8zm0 3a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);

const ErrorIcon = ({
  fillColor = WARNING_COLOR,
  width = 60,
  height = 60,
}: IconDefaultProps): React.ReactElement => (
  <svg
    fill="none"
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.5715 4.375H30C15.8477 4.375 4.375 15.8477 4.375 30C4.375 44.1523 15.8477 55.625 30 55.625C44.1523 55.625 55.625 44.1523 55.625 30C55.625 19.5725 49.3388 10.3062 39.8823 6.35018C39.5639 6.21696 39.1977 6.36712 39.0645 6.68555C38.9313 7.00399 39.0815 7.37012 39.3999 7.50334C48.3953 11.2665 54.375 20.0809 54.375 30C54.375 43.4619 43.4619 54.375 30 54.375C16.5381 54.375 5.625 43.4619 5.625 30C5.625 16.5381 16.5381 5.625 30 5.625H32.5715C32.9167 5.625 33.1965 5.34518 33.1965 5C33.1965 4.65482 32.9167 4.375 32.5715 4.375Z"
      fill={fillColor}
    />
    <path
      d="M31.9468 4.99709L31.8056 35.3096C31.8056 36.1754 31.1061 36.875 30.2431 36.875H29.2754C28.4124 36.875 27.7129 36.1754 27.7129 35.3125V16.5625C27.7129 16.2173 27.4331 15.9375 27.0879 15.9375C26.7427 15.9375 26.4629 16.2173 26.4629 16.5625V35.3125C26.4629 36.8658 27.7221 38.125 29.2754 38.125H30.2431C31.7964 38.125 33.0556 36.8658 33.0556 35.3125L33.1968 5.00291C33.1984 4.65774 32.9198 4.37661 32.5747 4.37501C32.2295 4.3734 31.9484 4.65192 31.9468 4.99709Z"
      fill={fillColor}
    />
    <path
      clipRule="evenodd"
      d="M33.1963 43.7383C33.1963 45.6368 31.6573 47.1758 29.7588 47.1758C27.8603 47.1758 26.3213 45.6368 26.3213 43.7383C26.3213 41.8398 27.8603 40.3008 29.7588 40.3008C31.6573 40.3008 33.1963 41.8398 33.1963 43.7383ZM27.5714 43.7383C27.5714 44.9465 28.5507 45.9258 29.7589 45.9258C30.967 45.9258 31.9464 44.9465 31.9464 43.7383C31.9464 42.5302 30.967 41.5508 29.7589 41.5508C28.5507 41.5508 27.5714 42.5302 27.5714 43.7383Z"
      fill={fillColor}
      fillRule="evenodd"
    />
  </svg>
);

const EditIcon = ({
  fillColor = PP_PRIMARY_COLOR,
  width = 24,
  height = 24,
}: IconDefaultProps): React.ReactElement => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2781 8.77045C11.2866 8.76136 11.2952 8.75239 11.3041 8.74354L16.7547 3.29289C17.1452 2.90237 17.7784 2.90237 18.1689 3.29289L20.7084 5.83231C21.0989 6.22283 21.0989 6.856 20.7084 7.24652L16.7799 11.1749C16.7715 11.184 16.7628 11.193 16.754 11.2018L9.37861 18.5772C9.11356 18.8423 8.77935 19.0275 8.41411 19.1118L4.61281 19.989C4.25278 20.0721 3.9301 19.7494 4.01319 19.3894L4.89041 15.5881C4.97469 15.2229 5.15993 14.8887 5.42498 14.6236L11.2781 8.77045ZM14.5677 7.60128L17.4618 4.70711L19.2941 6.53942L16.4 9.43359L14.5677 7.60128Z"
      fill={fillColor}
    />
  </svg>
);

const SuccessIcon = ({
  fillColor = PP_SUCCESS_COLOR,
  width = 48,
  height = 48,
}: IconDefaultProps): React.ReactElement => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5007 42.6667C34.81 42.6667 43.1673 34.3093 43.1673 24C43.1673 13.6907 34.81 5.33333 24.5007 5.33333C14.1913 5.33333 5.83398 13.6907 5.83398 24C5.83398 34.3093 14.1913 42.6667 24.5007 42.6667ZM34.7794 18.1785C35.4523 17.3026 35.2879 16.047 34.412 15.374C33.5361 14.701 32.2805 14.8655 31.6075 15.7414L21.7003 28.6358L17.2941 24.0998C16.5244 23.3075 15.2582 23.2891 14.4659 24.0587C13.6736 24.8284 13.6553 26.0946 14.4249 26.8869L20.4211 33.0597C21.2821 33.946 22.729 33.8622 23.4819 32.8823L34.7794 18.1785Z"
      fill={fillColor}
    />
  </svg>
);

const MinusIcon: React.FC<IconDefaultProps> = ({
  fillColor = PP_SECONDARY_COLOR,
  width = 30,
  height = 30,
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      fill={fillColor}
      d="M12.5 11.5h5a.5.5 0 1 1 0 1h-11a.5.5 0 1 1 0-1h6z"
    />
  </svg>
);

const QuestionIcon: React.FC<IconDefaultProps> = ({
  fillColor = PP_PRIMARY_COLOR,
  width = 24,
  height = 24,
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      fill={fillColor}
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
    />
  </svg>
);

export {
  CartIcon,
  ChevronIcon,
  EditIcon,
  ErrorIcon,
  InfoIcon,
  SuccessIcon,
  MinusIcon,
  QuestionIcon,
};
